import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export default class Link extends AuxiliumComponent {
	static observable = ["href", "target", "rel", "download"];

	parsedCallback() {
		const anchor = document.createElementWithContents("a", this.childNodes, {
			href: Browser.ResolveRelativeURL(this.href)
		});

		if (this.target) { anchor.target = this.target; }
		if (this.rel) { anchor.rel = this.rel; }
		if (this.download) { anchor.download = true; }

		this.appendChild(anchor);
	}
}
